import React, { useState, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import LogoN7 from '../../Img/LogoN7_FondoTransparente.png'
import LogoLatitudVirtual from '../../Img/LogoLV_FondoTransparente.png';
import { function_ABM_ZON_Plantas_Leer, function_ABM_ZON_Plantas_LeerConLogo } from "neftis7_apicaller/src/funciones/ABM/ZON/ABM_ZON_Plantas";

const Login = (ParametroGlobalizadorDeCompania) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [codigoCompania, setCodigoCompania] = useState("");
  const [controlCompaniaVisible, setControlCompaniaVisible] = useState(true);
  const [controlEmpresaVisible, setControlEmpresaVisible] = useState(true);
  const [controlPlantaVisible, setControlPlantaVisible] = useState(true);
  const [controlUsuarioVisible, setControlUsuarioVisible] = useState(true);
  const [controlPasswordVisible, setControlPasswordVisible] = useState(true);
  const [codigoEmpresa, setCodigoEmpresa] = useState("");
  const [codigoPlanta, setCodigoPlanta] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [plantas, setPlantas] = useState([]);
  const [redirect, setRedirect] = useState(false);
  const [authError, setAuthError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [esSoloPVenta, setEsSoloPVenta] = useState(false);
  const { ParametroCompania, ParametroEmpresa, ParametroPlanta, ParametroUsuario, ParametroPassword } = useParams();
  const { Varios: { TratamientoDeVariableBoolean } } = require('neftis7_apicaller');
  const { ABM_ZON_Empresas: { function_ABM_ZON_Empresas_ListarEmpresasDeCompania } } = require('neftis7_apicaller');
  const { ABM_ZON_Plantas: { function_ABM_ZON_Plantas_ListarPlantasDeEmpresa } } = require('neftis7_apicaller');
  const { ABM_EEX_Personas: { function_ABM_EEX_Personas_ValidarParaIngreso } } = require('neftis7_apicaller');
  const [logo, setLogo] = useState(LogoLatitudVirtual);

  useEffect(() => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    localStorage.setItem("Estilo", '/CSS/dx.light.css');

    if (ParametroGlobalizadorDeCompania.prop != undefined && ParametroGlobalizadorDeCompania.prop != null && ParametroGlobalizadorDeCompania.prop !== "") {
      if (ParametroGlobalizadorDeCompania.prop === "SALIMOS") {
        //setCodigoCompania("OTR");
        //setCodigoEmpresa("OTR");
        //setCodigoPlanta("COL");

        //setControlCompaniaVisible(false)
        //setControlEmpresaVisible(false)
        //setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "CILANTRO") {
        //setCodigoCompania("OTR");
        //setCodigoEmpresa("OTR");
        //setCodigoPlanta("COL");

        //setControlCompaniaVisible(false)
        //setControlEmpresaVisible(false)
        //setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "VIAFAR") {
        //setCodigoCompania("OTR");
        //setCodigoEmpresa("OTR");
        //setCodigoPlanta("COL");

        //setControlCompaniaVisible(false)
        //setControlEmpresaVisible(false)
        //setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "AVANT") {
        //setCodigoCompania("OTR");
        //setCodigoEmpresa("OTR");
        //setCodigoPlanta("COL");

        //setControlCompaniaVisible(false)
        //setControlEmpresaVisible(false)
        //setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "EEFE") {
        //setCodigoCompania("OTR");
        //setCodigoEmpresa("OTR");
        //setCodigoPlanta("COL");

        //setControlCompaniaVisible(false)
        //setControlEmpresaVisible(false)
        //setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "EMELI") {
        //setCodigoCompania("OTR");
        //setCodigoEmpresa("OTR");
        //setCodigoPlanta("COL");

        //setControlCompaniaVisible(false)
        //setControlEmpresaVisible(false)
        //setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "KUFO") {
        setCodigoCompania("OTR");
        setCodigoEmpresa("OTR");
        setCodigoPlanta("COL");

        setControlCompaniaVisible(false)
        setControlEmpresaVisible(false)
        setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "MERLE") {
        setCodigoCompania("MER");
        setCodigoEmpresa("MER");
        setCodigoPlanta("PL2");

        setControlCompaniaVisible(false)
        setControlEmpresaVisible(false)
        setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "JUMPIN") {
        setCodigoCompania("301");
        setCodigoEmpresa("E01");
        setCodigoPlanta("P01");

        setControlCompaniaVisible(false)
        setControlEmpresaVisible(false)
        setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "PLAYLAND") {
        setCodigoCompania("302");
        setCodigoEmpresa("E01");
        setCodigoPlanta("P01");

        setControlCompaniaVisible(false)
        setControlEmpresaVisible(false)
        setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "CRAZY") {
        setCodigoCompania("304");
        setCodigoEmpresa("E01");
        setCodigoPlanta("P05");

        setControlCompaniaVisible(false)
        setControlEmpresaVisible(false)
        setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "DEMOPARQUES") {
        setCodigoCompania("000");
        setCodigoEmpresa("E00");
        setCodigoPlanta("P05");

        setControlCompaniaVisible(false)
        setControlEmpresaVisible(false)
        setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "DEMOTEXTIL") {
        setCodigoCompania("000");
        setCodigoEmpresa("E07");
        setCodigoPlanta("P07");

        setControlCompaniaVisible(false)
        setControlEmpresaVisible(false)
        setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "DEMOBEBIDAS") {
        setCodigoCompania("000");
        setCodigoEmpresa("E08");
        setCodigoPlanta("P08");

        setControlCompaniaVisible(false)
        setControlEmpresaVisible(false)
        setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "DEMOALIMENTOS") {
        setCodigoCompania("000");
        setCodigoEmpresa("E09");
        setCodigoPlanta("P09");

        setControlCompaniaVisible(false)
        setControlEmpresaVisible(false)
        setControlPlantaVisible(false)
      }
      else if (ParametroGlobalizadorDeCompania.prop === "DEMOMAYORISTAS") {
        setCodigoCompania("000");
        setCodigoEmpresa("E10");
        setCodigoPlanta("P10");

        setControlCompaniaVisible(false)
        setControlEmpresaVisible(false)
        setControlPlantaVisible(false)
      }
    }
    else {
      if (ParametroCompania != undefined && ParametroCompania != null && ParametroCompania !== "") {
        setCodigoCompania(ParametroCompania.toUpperCase());
        setControlCompaniaVisible(false)
        handleTxtCompaniaBlur()
      }

      if (ParametroEmpresa != undefined && ParametroEmpresa != null && ParametroEmpresa !== "") {
        setCodigoEmpresa(ParametroEmpresa);
        setControlEmpresaVisible(false)
      }

      if (ParametroPlanta != undefined && ParametroPlanta != null && ParametroPlanta !== "") {
        setCodigoPlanta(ParametroPlanta);
        setControlPlantaVisible(false)
      }

      if (ParametroUsuario != undefined && ParametroUsuario != null && ParametroUsuario !== "") {
        setEmail(ParametroUsuario)
        setControlUsuarioVisible(false)
      }

      if (ParametroPassword != undefined && ParametroPassword != null && ParametroPassword !== "") {
        setPassword(ParametroPassword)
        setControlPasswordVisible(false)

        handleSubmit()
      }
    }
  }, []);


  useEffect(() => {
    if (!controlPasswordVisible &&
      codigoCompania != undefined && codigoCompania != null && codigoCompania !== "" &&
      codigoEmpresa != undefined && codigoEmpresa != null && codigoEmpresa !== "" &&
      codigoPlanta != undefined && codigoPlanta != null && codigoPlanta !== "" &&
      email != undefined && email != null && email !== "" &&
      password != undefined && password != null && password !== "") {
      handleSubmit()
    }
  }, [codigoCompania, codigoEmpresa, codigoPlanta, email, password]);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePwdChange = (event) => {
    setPassword(event.target.value);
  };

  const handleTxtCompaniaChange = (event) => {
    setCodigoCompania(event.target.value.toUpperCase());
  };

  const handleTxtCompaniaBlur = async () => {
    try {
      if (codigoCompania !== "") {
        const resultEmpresas = await function_ABM_ZON_Empresas_ListarEmpresasDeCompania(codigoCompania);
        if (Array.isArray(resultEmpresas.data) && resultEmpresas.data.length > 0) {
          setEmpresas(resultEmpresas.data);
        } else {
          setEmpresas([]);
          setPlantas([]);
          setCodigoEmpresa("");
          setCodigoPlanta("");
        }
      }
    } catch (error) {
      alert("Error al cargar las Empresas:" + error);
    }
  };

  const handleDrpEmpresasChange = async (event) => {
    const selectedEmpresa = event.target.value;
    setCodigoEmpresa(selectedEmpresa);
    localStorage.setItem("DescripcionEmpresa", event.target.options[event.target.selectedIndex].text);

    if (selectedEmpresa !== "") {
      try {
        const resultPlantas = await function_ABM_ZON_Plantas_ListarPlantasDeEmpresa(codigoCompania, selectedEmpresa);
        if (Array.isArray(resultPlantas.data) && resultPlantas.data.length > 0) {
          setPlantas(resultPlantas.data);
        } else {
          setPlantas([]);
          setCodigoPlanta("");
        }
      } catch (error) {
        alert("Error al cargar las Plantas:" + error);
      }
    }
  };

  const handleDrpPlantasChange = (event) => {
    const selectedPlanta = event.target.value;
    setCodigoPlanta(selectedPlanta);
    localStorage.setItem("DescripcionPlanta", event.target.options[event.target.selectedIndex].text);

    localStorage.setItem("CodigoCompania", codigoCompania);
    localStorage.setItem("CodigoEmpresa", codigoEmpresa);
    localStorage.setItem("CodigoPlanta", selectedPlanta);
    localStorage.setItem("LoginCodigoCompania", codigoCompania);
    localStorage.setItem("LoginCodigoEmpresa", codigoEmpresa);
    localStorage.setItem("LoginCodigoPlanta", selectedPlanta);

    const getData = async () => {
      const datosDocumento = await function_ABM_ZON_Plantas_LeerConLogo(selectedPlanta)

      if (datosDocumento.data[0]?.Logo) {
        let mimeType = "image/jpeg"; // Valor por defecto

        // Detectar el formato a partir del encabezado de la cadena Base64
        if (datosDocumento.data[0].Logo.startsWith("/9j/")) mimeType = "image/jpeg";
        else if (datosDocumento.data[0].Logo.startsWith("iVBOR")) mimeType = "image/png";
        else if (datosDocumento.data[0].Logo.startsWith("R0lGOD")) mimeType = "image/gif";

        const logoUrl = `data:${mimeType};base64,${datosDocumento.data[0].Logo}`;
        setLogo(logoUrl);
      }
    }

    getData()
  };

  const handleSelectChange = (event) => {
    localStorage.setItem("Estilo", event.target.value);
  };


  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault(); // Solo llamamos preventDefault si event es válido
    }
    setIsLoading(true);

    try {
      const resultUsuario = await function_ABM_EEX_Personas_ValidarParaIngreso(codigoCompania, codigoEmpresa, codigoPlanta, email, password);
      if (Array.isArray(resultUsuario.data) && resultUsuario.data.length > 0) {
        const user = resultUsuario.data[0];
        setEsSoloPVenta(user.EsSoloPVenta)
        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem("user", JSON.stringify(user.IdPersona));
        localStorage.setItem("IdPersona", parseInt(user.IdPersona));
        localStorage.setItem("Usuario", user.Nombre + ' ' + user.Apellido);
        localStorage.setItem("Terminal", 0);
        localStorage.setItem("EsSoloPVenta", TratamientoDeVariableBoolean(user.EsSoloPVenta));
        localStorage.setItem("EsAdmin", await TratamientoDeVariableBoolean(user.Admin));
        localStorage.setItem("PuedeSimularEmpresaPlantaTerminal", await TratamientoDeVariableBoolean(user.PuedeSimularEmpresaPlantaTerminal));
        localStorage.setItem("CodigoCompania", codigoCompania);
        localStorage.setItem("CodigoEmpresa", codigoEmpresa);
        localStorage.setItem("CodigoPlanta", codigoPlanta);
        localStorage.setItem("LoginCodigoCompania", codigoCompania);
        localStorage.setItem("LoginCodigoEmpresa", codigoEmpresa);
        localStorage.setItem("LoginCodigoPlanta", codigoPlanta);

        setRedirect(true);
      } else {
        localStorage.setItem("isLoggedIn", false);
        setAuthError(true);
        setRedirect(false);
      }
    } catch (error) {
      alert("Error al validar el usuario:" + error);
      setAuthError(true);
    } finally {
      setIsLoading(false);
    }
  };

  if (redirect) {
    if (esSoloPVenta) {
      return <Navigate to="/VEN_PuntoDeVenta_" />;
    }
    else {
      return <Navigate to="/DashBoardPrincipal" />;
    }
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: '#f0f2f5'
    }}>
      <div style={{
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        display: 'flex',
        overflow: 'hidden',
        width: '700px',
        maxWidth: '95%'
      }}>
        {/* Logo Cliente */}
        <div style={{
          flex: '1',
          background: '#e9ecef',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px'
        }}>
          <img
            src={logo}
            alt="Logo Cliente"
            style={{ maxWidth: '100%', maxHeight: '150px' }}
          />
        </div>

        {/* Login */}
        <div style={{
          flex: '2',
          padding: '30px'
        }}>
          <div style={{
            textAlign: 'center',
            marginBottom: '20px',
            fontWeight: 'bold',
            fontSize: '1.2rem'
          }}>
            INGRESO
          </div>
          <form onSubmit={handleSubmit}>
            {controlCompaniaVisible && (
              <div className="form-group">
                <label htmlFor="txtCompania">Compañía</label>
                <input
                  type="text"
                  id="txtCompania"
                  className="form-control"
                  placeholder="COMPAÑÍA"
                  autoFocus
                  required
                  onBlur={handleTxtCompaniaBlur}
                  onChange={handleTxtCompaniaChange}
                />
              </div>
            )}

            {controlEmpresaVisible && (
              <div className="form-group">
                <label htmlFor="drpEmpresas">Empresa</label>
                <select
                  name="drpEmpresas"
                  id="drpEmpresas"
                  className="form-control"
                  onChange={handleDrpEmpresasChange}
                >
                  <option value="">Seleccionar:</option>
                  {empresas.map((e) => (
                    <option key={e.CodigoEmpresa} value={e.CodigoEmpresa}>{e.Descripcion}</option>
                  ))}
                </select>
              </div>
            )}

            {controlPlantaVisible && (
              <div className="form-group">
                <label htmlFor="drpPlantas">Planta</label>
                <select
                  name="drpPlantas"
                  id="drpPlantas"
                  className="form-control"
                  onChange={handleDrpPlantasChange}
                >
                  <option value="">Seleccionar:</option>
                  {plantas.map((p) => (
                    <option key={p.CodigoPlanta} value={p.CodigoPlanta}>{p.Descripcion}</option>
                  ))}
                </select>
              </div>
            )}

            {controlUsuarioVisible && (
              <div className="form-group">
                <label htmlFor="inputEmail">Usuario</label>
                <input
                  type="text"
                  id="inputEmail"
                  className={`form-control ${authError ? 'is-invalid' : ''}`}
                  placeholder="USUARIO"
                  required
                  name="username"
                  onChange={handleEmailChange}
                />
                <div className="invalid-feedback">Es necesario ingresar un usuario válido.</div>
              </div>
            )}

            {controlPasswordVisible && (
              <div className="form-group">
                <label htmlFor="inputPassword">Contraseña</label>
                <input
                  type="password"
                  className={`form-control ${authError ? 'is-invalid' : ''}`}
                  id="inputPassword"
                  required
                  placeholder="******"
                  name="password"
                  onChange={handlePwdChange}
                />
                <div className="invalid-feedback">Es necesario ingresar una contraseña válida.</div>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="styleSelect">Seleccionar estilo</label>
              <select
                className="form-control"
                id="styleSelect"
                onChange={handleSelectChange}
              >
                <option value="/CSS/dx.light.css">Luz</option>
                <option value="/CSS/dx.carmine.css">Luz Rojo</option>
                <option value="/CSS/dx.softblue.css">Luz Azul</option>
                <option value="/CSS/dx.greenmist.css">Luz Verde</option>
                <option value="/CSS/dx.dark.css">Oscuro</option>
                <option value="/CSS/dx.darkmoon.css">Oscuro Azul</option>
                <option value="/CSS/dx.darkviolet.css">Oscuro Violeta</option>
                <option value="/CSS/dx.contrast.css">Contraste</option>
              </select>
            </div>

            <div className="form-group">
              <button className="btn btn-primary btn-block" type="submit" disabled={isLoading}>
                INGRESAR&nbsp;&nbsp;
                {isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
              </button>
            </div>
          </form>
        </div>

        {/* Logo Neftis */}
        <div style={{
          flex: '1',
          background: '#e9ecef',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px'
        }}>
          <img
            src={LogoN7}
            alt="Logo Neftis"
            style={{ maxWidth: '100%', maxHeight: '150px' }}
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
